import React from 'react';
import ModuleRoute from 'holocron-module-route';
import HeaderOnly from './components/header-footer/HeaderOnly';
import Home from './components/header-footer/Home';
import FooterOnly from './components/header-footer/FooterOnly';
import ContentOnly from './components/header-footer/ContentOnly';
import PageWrapper from './components/header-footer/PageWrapper';
import Nav from './components/navigation/Nav';
import Cmv from './components/cmv/Cmv';

const childRoutes = () => [
  <ModuleRoute key="axp-demo">
    <ModuleRoute
      path="demo/wrapped/:moduleName"
      moduleName="axp-demo"
    />
    <ModuleRoute
      path="demo/unwrapped/:moduleName"
      moduleName="axp-demo"
    />
  </ModuleRoute>,
  <ModuleRoute key="/header-only" path="/header-only" component={HeaderOnly} />,
  <ModuleRoute key="/footer-only" path="/footer-only" component={FooterOnly} />,
  <ModuleRoute key="/content-only" path="/content-only" component={ContentOnly} />,
  <ModuleRoute key="/" path="/" component={Home} />,
  <ModuleRoute key="/page-wrapper" path="/page-wrapper" component={PageWrapper} />,
  <ModuleRoute key="/nav-only" path="/nav-only" component={Nav} />,
  <ModuleRoute key="/cmv" path="/cmv" component={Cmv} />,
];

export default childRoutes;
